import { Menu } from 'lucide-react'
import { useLayout } from '@/contexts/LayoutContext'

interface HeaderProps {
  title: string
}

/**
 * Sayfa başlık çubuğu — halka açık sitenin üst çubuğuyla aynı ölçü ve dil:
 * 68px yükseklik, `bg-black/25 backdrop-blur-sm` cam, `border-white/10`
 * saç teli. Sidebar'ın marka bloğu da aynı yüksekliktedir, dolayısıyla
 * panelin üst satırı baştan sona tek bir hat olarak okunur.
 *
 * Başlık, sitenin hero kicker'ıyla aynı biçim: kısa bir kızıl çizgi, sonra
 * display yüzünde büyük harf ve geniş harf aralığı. Sayfa adı bir cümle değil
 * bir etikettir; sitede de öyle basılır.
 */
export default function Header({ title }: HeaderProps) {
  const { onMenuToggle } = useLayout()

  return (
    <header className="flex h-[68px] shrink-0 items-center gap-3 border-b border-white/10 bg-black/25 px-5 backdrop-blur-sm">
      <button
        onClick={onMenuToggle}
        className="shrink-0 text-muted-foreground transition-colors hover:text-foreground md:hidden"
        aria-label="Toggle menu"
      >
        <Menu className="h-5 w-5" />
      </button>
      <span aria-hidden className="hidden h-px w-6 shrink-0 bg-primary md:block" />
      <h2 className="truncate font-display text-[15px] font-bold uppercase tracking-[0.14em]">
        {title}
      </h2>
    </header>
  )
}
